import Component from '@bythepixel/component-loader';
import throttle from '@Core/utility/eventThrottle';
import Breakpoints from '@Front/constants/breakpoints';

const DEFAULTS = {
  modalContainer: '[data-comp-modal-container]',
  modalTrigger: '[data-comp-modal-trigger]',
  closeButton: '[data-comp-modal-close-button]',
};

const MODAL_EVENTS = {
  opening: 'opening',
  opened: 'opened',
  closing: 'closing',
  closed: 'closed',
};

export default class ModalController extends Component {
  static selector = '[data-comp-modal-controller]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.containers = document.querySelectorAll(this.$options.modalContainer);
    this.triggers = document.querySelectorAll(this.$options.modalTrigger);
    this.mount();
  }

  openModal = (container) => {
    container.dataset.modalState = MODAL_EVENTS.opening;
    container.showModal();
    this.disablePageScroll();
  }

  closeModal = (container) => {
    container.dataset.modalState = MODAL_EVENTS.closing;
  }

  disablePageScroll() {
    document.body.classList.add('block-scroll');
  }

  enablePageScroll() {
    document.body.classList.remove('block-scroll');
  }

  mobileMenuShouldShow() {
    const { desktop: breakpoint } = Breakpoints;
    return window.innerWidth < breakpoint;
  }

  mount() {
    this.triggers.forEach(trigger => {
      const triggerTargetName = trigger.dataset.compModalTarget;
      const targetContainer = document.querySelector(`[data-comp-modal-id="${triggerTargetName}"]`);
      trigger.addEventListener('click', () => {
        this.openModal(targetContainer);
      });
    });

    this.containers.forEach(container => {
      const closeButton = container.querySelector(this.$options.closeButton);

      closeButton.addEventListener('click', () => {
        this.closeModal(container);
      });

      container.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.closeModal(container);
      });

      // this is for the social share modal
      container.addEventListener('click', (e) => {
        if (e.target.parentNode.dataset.compSocialShareButton) {
          this.closeModal(container);
        }
      });

      /**
       * If user is resizing window, the mobile menu should automatically close above
       * some breakpoint
       */
      window.addEventListener('resize', throttle(() => {
        const mobileNav = document.querySelector('[data-comp-modal-id="mobile-nav"]');
        if (!this.mobileMenuShouldShow() && mobileNav.dataset.modalState === 'opened') {
          this.closeModal(mobileNav);
        }
      }));

      container.addEventListener('animationend', (e) => {
        // this is to account for any other animations added in by emojis, etc.
        if (e.animationName !== 'showModal') {
          return;
        }

        switch (container.dataset.modalState) {
        case 'opening':
          container.dataset.modalState = MODAL_EVENTS.opened;
          break;
        default:
          container.dataset.modalState = MODAL_EVENTS.closed;
          container.close();
          this.enablePageScroll();
        }
      });
    });
  }
}
